import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import LandingPage from './components/LandingPage';
import SubmissionForm from './components/SubmissionForm';
import PhotoUploadPage from './components/PhotoUploadPage';
import FinalSubmissionPage from './components/FinalSubmissionPage';
import TierSelectionPage from './components/TierSelectionPage';
import PostingStatusPage from './components/PostingStatusPage';
import ThankYouPage from './components/ThankYouPage';
import StreamerThankYouPage from './components/StreamerThankYouPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import AdminDashboard from './components/AdminDashboard';
import InstagramAppReviewConnect from './components/InstagramAppReviewConnect';
import StreamerSubmissionForm from './components/StreamerSubmissionForm';
import StreamerMediaUploadPage from './components/StreamerMediaUploadPage';
import StreamerTierSelectionPage from './components/StreamerTierSelectionPage';
import StreamerPostingStatusPage from './components/StreamerPostingStatusPage';
import StreamerUniversityRedirect from './components/StreamerUniversityRedirect';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/submit/streamer-university" element={<StreamerUniversityRedirect targetPath="/streamer/submit" />} />
        <Route path="/submit/streamer-university/photos" element={<StreamerUniversityRedirect targetPath="/streamer/media" />} />
        <Route path="/submit/streamer-university/tier-selection" element={<StreamerUniversityRedirect targetPath="/streamer/tier-selection" />} />
        <Route path="/submit/:school" element={<SubmissionForm />} />
        <Route path="/submit/:school/photos" element={<PhotoUploadPage />} />
        <Route path="/submit/:school/final" element={<FinalSubmissionPage />} />
        <Route path="/submit/:school/tier-selection" element={<TierSelectionPage />} />
        <Route path="/streamer/submit" element={<StreamerSubmissionForm />} />
        <Route path="/streamer/media" element={<StreamerMediaUploadPage />} />
        <Route path="/streamer/tier-selection" element={<StreamerTierSelectionPage />} />
        <Route path="/streamer/posting-status/:submissionId" element={<StreamerPostingStatusPage />} />
        <Route path="/streamer/thank-you/:submissionId" element={<StreamerThankYouPage />} />
        <Route path="/posting-status/:submissionId" element={<PostingStatusPage />} />
        <Route path="/thank-you/:submissionId" element={<ThankYouPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/instagram-connect" element={<InstagramAppReviewConnect />} />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
